export default "__VITE_ASSET__C2CH4Wfk__"